"use client";

import { cn } from "@gettactic/helpers";
import React from "react";

export type EmptyAction = {
  label: string;
  onClick: () => void;
};

interface ReportEmptyStateProps {
  title: string;
  /** Why it is empty and what usually fixes it. */
  hint?: string;
  actions?: EmptyAction[];
  className?: string;
}

/** An empty result that says why and offers the next click. */
export const ReportEmptyState: React.FC<ReportEmptyStateProps> = ({
  title,
  hint,
  actions = [],
  className
}) => (
  <div
    className={cn(
      "flex flex-col items-center justify-center gap-2 py-12 text-center",
      className
    )}
  >
    <span className="font-medium text-[13px] text-neutral-700">{title}</span>
    {hint ? (
      <span className="max-w-[360px] text-[12px] text-neutral-400 leading-[17px]">
        {hint}
      </span>
    ) : null}
    {actions.length > 0 ? (
      <div className="mt-1 flex flex-wrap justify-center gap-2">
        {actions.map((a) => (
          <button
            type="button"
            key={a.label}
            onClick={a.onClick}
            className="rounded-full border border-neutral-200 bg-white px-3 py-1 text-[12px] text-neutral-700 hover:border-neutral-300 hover:bg-neutral-50"
          >
            {a.label}
          </button>
        ))}
      </div>
    ) : null}
  </div>
);
